<template>
  <v-container
    class="my-6"
  >
    <v-row
      align="start"
      justify="center"
      class="text-center mb-1"
    >
      <v-col>
        <v-icon x-large>
          supervisor_account
        </v-icon>
        <h2 class="display-2">
          Deine Mannschaft
        </h2>
      </v-col>
    </v-row>

    <v-row class="my-6 d-none d-sm-flex">
      <v-col class="text-center">
        <v-btn-toggle
          v-model="toggleActive"
          rounded
          background-color="primary darken-1"
          dark
        >
          <v-btn to="/mannschaft">
            Übersicht
          </v-btn>
          <v-btn to="/aufstellung">
            Aufstellung
          </v-btn>
          <v-btn to="/training">
            Training / Trainingslager
          </v-btn>
          <v-btn>
            Verträge
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <v-row
      align="start"
      justify="center"
      class="text-center mb-1"
    >
      <v-col cols="12" class="display-2">
        Verträge
      </v-col>
    </v-row>

    <page-loading :is-page-loading="$store.state.pageLoading" />

    <my-alert
      v-if="$store.state.error"
      :error="$store.state.error"
      :title="$store.state.errorTitle"
      type="error"
    />

    <players
      :players="$store.state.teamStore.players | sortByPosition"
      :with-contract="true"
    />
    <v-divider class="mb-6 mt-12" />
    <v-row
      class="my-6"
      justify="center"
    >
      <v-col cols="10">
        <h3 class="title">
          Neue Spieler verpflichten:
        </h3>
        <p class="body-1">
          Du kannst am Spieltag, maximal 3 mal den Generator betätigen.<br>
          Betätigungen Heute: <b>{{ $store.state.teamStore.createdNewPlayersCounter }}</b>
        </p>
      </v-col>
    </v-row>

    <v-row
      justify="center"
    >
      <v-col
        cols="10"
      >
        <v-card
          v-if="$store.state.teamStore.players.length < 12 && $store.state.teamStore.createdNewPlayersCounter < 3"
        >
          <v-card-text>
            <v-select
              :items="playerAges"
              v-model="age"
              label="Select"
              single-line
              hint="Alter vom neuen Spieler wählen"
              persistent-hint
            />
          </v-card-text>
          <v-card-actions>
            <v-btn
              :loading="$store.state.loading"
              :disabled="$store.state.loading"
              color="primary"
              @click.native="findNewPlayers"
              dark
              class="mx-auto"
            >
              Spieler erstellen
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card
          v-else
        >
          <v-card-text>
            Du hast die maximale Anzahl an Spieler erreicht oder die Funktion heute schon zu oft genutzt.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      justify="center"
    >
      <v-col cols="10" class="my-8">
        <h3 class="headline">
          Deine letzte Suchanfrage hat folgende Spieler gefundene:
        </h3>
      </v-col>
    </v-row>

    <players
      :players="$store.state.teamStore.createdNewPlayers | sortByPosition"
      :new-player="true"
    />
  </v-container>
</template>

<script>
import { ROOT_SET_SNACKBAR } from '../store/mutation-types'
// const R = require('ramda')

export default {
  name: 'Vertrag',
  components: {
    // draggable
  },
  metaInfo: {
    title: 'Mannschaft - Verträge'
  },
  data () {
    return {
      toggleActive: 3,
      playerAges: [
        { text: '16 Jahre', value: 16 },
        { text: '17 Jahre', value: 17 },
        { text: '18 Jahre', value: 18 },
        { text: '19 Jahre', value: 19 }
      ],
      age: 16
    }
  },
  mounted: function () {
    // load generated players
  },
  computed: {

  },
  methods: {
    findNewPlayers: async function () {
      if (this.$store.state.teamStore.createdNewPlayersCounter < 3) {
        if (await this.$store.dispatch('teamStore/createNewPlayers', this.age)) {
          return true
        }
        return false
        // counter erhöhen und speichern in db
        // new players erhalten und counter erhöhen, der counter wird bei auswertung zurückgesetzt
        //
      }
      this.$store.commit(ROOT_SET_SNACKBAR, 'Du kannst für heute keinen weiteren Spieler mehr generieren.')
      return false
    }
  }
}
</script>
